<template>
  <el-dialog 
    :title="$t('serviceImplManage.addServiceImpl')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog">
    <el-form :model="addServiceImplInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('serviceImplManage.businessType')" prop="businessTypeCd">
        <el-input 
          v-model="addServiceImplInfo.businessTypeCd" 
          :placeholder="$t('serviceImplManage.requiredBusinessType')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.businessName')" prop="name">
        <el-input 
          v-model="addServiceImplInfo.name" 
          :placeholder="$t('serviceImplManage.requiredBusinessName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.invokeType')" prop="invokeType">
        <el-select 
          v-model="addServiceImplInfo.invokeType" 
          style="width:100%"
          :placeholder="$t('serviceImplManage.requiredInvokeType')">
          <el-option disabled value="">{{$t('serviceImplManage.requiredInvokeType')}}</el-option>
          <el-option value="1">{{$t('serviceImplManage.microservicePost')}}</el-option>
          <el-option value="2">{{$t('serviceImplManage.webservice')}}</el-option>
          <el-option value="3">{{$t('serviceImplManage.httpPost')}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.invokeUrl')" prop="url">
        <el-input 
          v-model="addServiceImplInfo.url" 
          :placeholder="$t('serviceImplManage.requiredInvokeUrl')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.kafkaTopic')">
        <el-input 
          v-model="addServiceImplInfo.messageTopic" 
          :placeholder="$t('serviceImplManage.optionalKafkaTopic')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.timeout')" prop="timeout">
        <el-input 
          v-model="addServiceImplInfo.timeout" 
          :placeholder="$t('serviceImplManage.requiredTimeout')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.retryCount')" prop="retryCount">
        <el-input 
          v-model="addServiceImplInfo.retryCount" 
          :placeholder="$t('serviceImplManage.requiredRetryCount')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('serviceImplManage.description')">
        <el-input 
          type="textarea" 
          v-model="addServiceImplInfo.description" 
          :placeholder="$t('serviceImplManage.optionalDescription')">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="saveServiceImplInfo">{{$t('common.save')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveServiceImpl } from '@/api/dev/serviceImplApi'

export default {
  name: 'AddServiceImpl',
  data() {
    return {
      dialogVisible: false,
      addServiceImplInfo: {
        businessTypeCd: '',
        name: '',
        invokeType: '',
        url: '',
        messageTopic: '',
        timeout: '60',
        retryCount: '3',
        description: ''
      },
      rules: {
        businessTypeCd: [
          { required: true, message: this.$t('serviceImplManage.requiredBusinessType'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('serviceImplManage.businessTypeLength'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('serviceImplManage.requiredBusinessName'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('serviceImplManage.businessNameLength'), trigger: 'blur' }
        ],
        invokeType: [
          { required: true, message: this.$t('serviceImplManage.requiredInvokeType'), trigger: 'change' }
        ],
        url: [
          { required: true, message: this.$t('serviceImplManage.requiredInvokeUrl'), trigger: 'blur' },
          { max: 200, message: this.$t('serviceImplManage.invokeUrlLength'), trigger: 'blur' }
        ],
        timeout: [
          { required: true, message: this.$t('serviceImplManage.requiredTimeout'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('serviceImplManage.timeoutNumber'), trigger: 'blur' }
        ],
        retryCount: [
          { required: true, message: this.$t('serviceImplManage.requiredRetryCount'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('serviceImplManage.retryCountNumber'), trigger: 'blur' }
        ],
        messageTopic: [
          { max: 50, message: this.$t('serviceImplManage.kafkaTopicLength'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('serviceImplManage.descriptionLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.addServiceImplInfo = {
        businessTypeCd: '',
        name: '',
        invokeType: '',
        url: '',
        messageTopic: '',
        timeout: '60',
        retryCount: '3',
        description: ''
      }
    },
    saveServiceImplInfo() {
      this.$refs.form.validate(valid => {
        if (valid) {
          saveServiceImpl(this.addServiceImplInfo).then(() => {
            this.$message.success(this.$t('common.saveSuccess'))
            this.$emit('success')
            this.closeDialog()
          }).catch(err => {
            console.error(err)
          })
        }
      })
    }
  }
}
</script>